import { AdminAppState, EventEntry } from '../../state';
import { getEvent } from './get-event';

export const getEventPageTitle = (eventKey: string) => (
  store: AdminAppState,
): EventEntry['event']['pageTitle'] => getEvent(eventKey)(store).pageTitle;
